module.exports = __webpack_public_path__ + "media/images/admin/magazines/icon_tulip-30dfd5a7384d2563587489d618cc2d7a.png";